<script setup lang="ts">
import OpengroundToSpeckle from '@/components/app/OpengroundToSpeckle.vue'
</script>

<template>
  <OpengroundToSpeckle></OpengroundToSpeckle>
</template>

<style scoped></style>
